import { render, staticRenderFns } from "./stripereturn.vue?vue&type=template&id=ef82d646"
import script from "./stripereturn.vue?vue&type=script&lang=js"
export * from "./stripereturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports